import { Dialog, DialogContent, DialogActions, Box } from "@mui/material";
import { useState, useEffect } from "react";
import CustomButton from "../../ui/button/Button";
import { getOldNotifications } from "../../components/functions/Notifications";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";

const AllNotificationsModal = ({ open, onClose, API_URL }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (open) {
      getOldNotifications(API_URL).then((data) => {
        setNotifications(data);
      });
    }
  }, [open]);

  const handleClose = () => {
    setNotifications([]);
    onClose();
  };

  const columns = [
    {
      accessorKey: "fecha",
      header: "Fecha",
      size: 50,
      accessorFn: (row) =>
        `${new Date(row.fecha).toLocaleString("es-MX", {
          dateStyle: "medium",
          timeStyle: "medium",
        })}`,
    },
    { accessorKey: "titulo", header: "Título", size: 100 },
    {
      accessorKey: "mensaje",
      header: "Mensaje",
      size: 200,
    },
    {
      accessorKey: "destinatario",
      header: "Destinatarios",
      size: 100,
    },
    {
      accessorKey: "urlThumb",
      header: "Imagen",
      size: 80,
      Cell: ({ cell }) => {
        if (!cell.row.original.urlThumb) return null;
        return (
          <Box
            component="img"
            src={`${API_URL}/${cell.row.original.urlThumb}`}
            alt={cell.row.original.titulo}
            sx={{
              maxHeight: "140px",
              maxWidth: "140px",
              objectFit: "contain",
              justifySelf: "center",
              borderRadius: "6px",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.05)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          />
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: notifications,
    enableSorting: false,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
  });

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <h2 style={{ margin: 0, padding: "16px 24px" }}>Notificaciones</h2>

      <DialogContent>
        <MaterialReactTable table={table} />
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cerrar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default AllNotificationsModal;
